"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-80c39cac"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "warning-row" };
const _hoisted_2 = { class: "warning-text" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "icon-row" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("svg", {
        width: "42",
        height: "42",
        viewBox: "0 0 85 85",
        xmlns: "http://www.w3.org/2000/svg"
    }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("path", {
            fill: "#EE162D",
            d: "M45.8,60.8c0,1.2-0.4,2.1-1.1,2.9c-0.4,0.5-1.3,1.1-2.9,1.1c-1.1,0-2.1-0.4-2.9-1.1c-0.8-0.8-1.2-1.7-1.2-2.9\n          c0-1.2,0.4-2.1,1.2-2.8c0.8-0.7,1.7-1,2.9-1c1.5,0,2.5,0.6,2.9,1.1C45.4,58.7,45.8,59.6,45.8,60.8z M44.6,30.3\n          c-1.5-1.4-4.3-1.3-5.6,0c-0.7,0.8-1,1.8-0.9,2.9l1,20c0,1.1,0.4,1.7,0.8,2.1c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.3-0.2,1.9-0.8\n          c0.4-0.5,0.7-1.1,0.8-2l1-20C45.5,32.1,45.3,31.2,44.6,30.3z M77,69.3c1.6-2.8,1.2-6.3-0.9-10L50.7,16.8C48.5,13,45.5,11,42.2,11\n          c-3.3,0-6.3,2.1-8.5,5.8L8.4,59.4c-2.2,3.7-2.5,7.2-0.9,10c1.6,2.8,5,4.4,9.5,4.4h50.7C72,73.7,75.4,72.2,77,69.3z M48.7,18\n          L74,60.6c1.7,2.9,2,5.6,0.9,7.6c-1.2,2.1-3.8,3.2-7.4,3.2H16.9c-3.6,0-6.2-1.1-7.4-3.2c-1.1-2-0.8-4.7,0.9-7.6L35.7,18\n          c1.8-3,4.1-4.6,6.5-4.6C44.6,13.4,46.9,15,48.7,18z"
        })
    ])
], -1 /* HOISTED */));
const _hoisted_4 = { class: "title-text" };
const _hoisted_5 = { class: "body-text" };
const vue_3 = require("vue");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const modal_js_1 = require("../js/modal.js");
const DEFAULT_BUTTON_TEXT = 'プランの詳細を確認する！';
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProUpgradeModal',
    setup(__props, { expose: __expose }) {
        const isVisible = (0, vue_3.ref)(false);
        const warningText = (0, vue_3.ref)('');
        const titleText = (0, vue_3.ref)('');
        const bodyText = (0, vue_3.ref)('');
        const buttonText = (0, vue_3.ref)(DEFAULT_BUTTON_TEXT);
        const modalName = modal_js_1.MODAL_NAMES.PRO_UPGRADE;
        function openModal(warning, title, body, btnText = DEFAULT_BUTTON_TEXT) {
            warningText.value = warning;
            titleText.value = title;
            bodyText.value = body;
            buttonText.value = btnText || DEFAULT_BUTTON_TEXT;
            isVisible.value = true;
        }
        function closeModal() {
            isVisible.value = false;
        }
        function onConfirm() {
            isVisible.value = false;
            window.location.href = DashURL("pro");
        }
        __expose({
            openModal,
            closeModal,
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    "modal-name": (0, vue_2.unref)(modalName),
                    class: "pro-upgrade-modal",
                    onCloseModal: closeModal,
                    onConfirm: onConfirm,
                    onCancel: closeModal
                }, {
                    "header-icon": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)(warningText.value), 1 /* TEXT */)
                        ]),
                        _hoisted_3
                    ]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(titleText.value), 1 /* TEXT */),
                        (0, vue_2.createElementVNode)("p", _hoisted_5, (0, vue_2.toDisplayString)(bodyText.value), 1 /* TEXT */)
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("button", {
                            class: "upgrade-btn",
                            onClick: onConfirm
                        }, (0, vue_2.toDisplayString)(buttonText.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modal-name"]))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
